import { render, staticRenderFns } from "./configuration_agreements_edit_section_modal.vue?vue&type=template&id=797c4114"
import script from "./configuration_agreements_edit_section_modal.vue?vue&type=script&lang=js"
export * from "./configuration_agreements_edit_section_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports